@if (published || showNav) {
  <app-nav></app-nav>
}
<div class="content__wrapper">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
